var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconIllumination = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .illumination_a {\n                fill: #fff;\n            }\n\n            .illumination_b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "illumination_a",
    d: "M14.361,35.589A1.72,1.72,0,0,0,16.076,37.3h6.861a1.72,1.72,0,0,0,1.715-1.715V33.874H14.361ZM19.506,3a12,12,0,0,0-6.861,21.852v3.876a1.72,1.72,0,0,0,1.715,1.715H24.652a1.72,1.72,0,0,0,1.715-1.715V24.852A12,12,0,0,0,19.506,3Zm4.888,19.039-1.458,1.029v3.945H16.076V23.068l-1.458-1.029a8.576,8.576,0,1,1,9.777,0Z",
    transform: "translate(2.679 1.684)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "illumination_b",
    width: 44,
    height: 44
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconIllumination);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_illumination.ce2a200db6863206ad612a6910dfc085.svg";